<template>
    <div class="invite-channel-search">
        <div class="input-group mb-3">
            <input class="form-control" :placeholder="Lang.get('partnerInvite.searchInputText')" type="text"
                   v-model="queryString" v-on:keyup.enter="search">
            <div class="input-group-append">
                <button class="btn btn-primary btn-static" type="submit" v-on:click="search"
                        v-bind:class="{disabled: searchStatus === 1, 'btn-loading': searchStatus === 1}"
                        style="padding-left: 2em; padding-right: 2em;">
                    <em class="fa fa-circle-o-notch fa-spin fa-loader"></em>
                    <span class="btn-text">{{ 'general.search' | lang }}</span>
                </button>
            </div>
        </div>
        <div>
            <table class="display nowrap table table-striped table-bordered" cellspacing="0" width="100%">
                <thead>
                <tr>
                    <th class="width-80">{{ 'partnerInvite.invite' | lang }}</th>
                    <th class="width-80"></th>
                    <th>{{ 'partnerInvite.channelName' | lang }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in searchResult" @click="pick(item.snippet.channelId)" class="cursor-pointer">
                    <td class="input-radio-channelId">
                        <label v-bind:for="item.snippet.channelId" class="custom-checkbox">
                            <input type="checkbox" :checked="item.snippet.channelId === form.youtube_channel_id">
                            <div class="control_indicator"></div>
                        </label>
                    </td>
                    <td>
                        <img v-bind:src="item.snippet.thumbnails.default.url" class="img-partner-invite"/>
                    </td>
                    <td>
                        <a target="_blank" class="channel-title" v-bind:href="'https://www.youtube.com/channel/'+item.snippet.channelId"> {{
                            item.snippet.channelTitle }} </a>
                        <p class="item-description">{{item.snippet.description}}</p>
                        <transition name="slide-fade">
                            <div v-if="pickedId === item.snippet.channelId" class="card-body p-t-10 cursor-default">
                                <form method="post" action="/partnerInvites/store" class="form-material m-t-15"
                                      @submit.prevent="handleForm" @keydown="form.errors.clear($event.target.name)">
                                    <div class="form-group ">

                                        <label for="youtube_channel_id" class="color-darkgray"> {{
                                            'partnerInvite.fields.channelId' | lang }} </label>

                                        <input type="text" id="youtube_channel_id" name="youtube_channel_id"
                                               class="form-control form-control-line" disabled
                                               v-model="form.youtube_channel_id">
                                        <span class="help is-danger" v-if="form.errors.has('youtube_channel_id')"
                                              v-text="form.errors.get('youtube_channel_id')"></span>
                                    </div>
                                    <div class="form-group ">
                                        <label for="email" class="color-darkgray"> {{ 'partnerInvite.fields.email' |
                                            lang }} </label>
                                        <input type="text" id="email" name="email"
                                               class="form-control form-control-line" value="" v-model="form.email">
                                        <span class="help is-danger" v-if="form.errors.has('email')"
                                              v-text="form.errors.get('email')"></span>
                                    </div>
                                    <div class="form-group ">
                                        <label for="revenue_share" class="color-darkgray"> {{
                                            'partnerInvite.fields.revenueShare' | lang }} </label>
                                        <input type="text" id="revenue_share" name="revenue_share"
                                               class="form-control form-control-line" value=""
                                               v-model="form.revenue_share">
                                        <span class="help is-danger" v-if="form.errors.has('revenue_share')"
                                              v-text="form.errors.get('revenue_share')"></span>
                                    </div>
                                    <button type="submit" class="btn btn-primary">
                                        {{ 'partnerInvite.createNew' | lang }}
                                    </button>
                                </form>
                            </div>
                        </transition>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import TForm from "./TForm";

    const SEARCH_STATUS = {
        READY: 0,
        SEARCHING: 1
    };

    export default {
        props: [],
        data() {
            return {
                queryString: '',
                searchResult: [],
                errors: [],
                searchStatus: SEARCH_STATUS.READY,
                pickedId: '',
                form: new TForm({
                    youtube_channel_id: '',
                    email: '',
                    revenue_share: 0,
                }),
            };
        },
        methods: {
            pick(id) {
                this.pickedId = id;
                this.form.youtube_channel_id = id;
            },
            search() {
                if (this.searchStatus !== SEARCH_STATUS.READY) {
                    return;
                }
                this.searchStatus = SEARCH_STATUS.SEARCHING;

                axios.get('/partnerInvites/channelSearch', {
                    params: {
                        'q': this.queryString,
                    }
                }).then(response => {
                    const result = response.data;
                    if (result.success) {
                        this.searchResult = result.data.items;
                        this.searchStatus = SEARCH_STATUS.READY;
                    }
                }).catch(error => {
                    this.errors.push(error);
                });
            },
            handleForm() {
                this.form.post('/partnerInvites/store').then(result => {
                    $.toast({
                        heading: 'Success',
                        text: result.message,
                        position: 'top-right',
                        loaderBg: '#85ff8f',
                        icon: 'success',
                        hideAfter: 3500,
                        stack: 6
                    });
                }).catch(error => {
                    $.toast({
                        heading: 'Error',
                        text: error.message,
                        position: 'top-right',
                        loaderBg: '#ff6b6b',
                        icon: 'error',
                        hideAfter: 3500,
                        stack: 6
                    });
                });
            }
        },
    };
</script>

<style lang="scss">
    .channel-title {
        font-size: 1.2em;
    }

    .item-description {
        font-size: 1em;
    }

    .input-radio-channelId {
        text-align: center;
    }

    .slide-fade-enter-active {
        transition: all .6s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(-10px);
        opacity: 0;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .cursor-default {
        cursor: default;
    }

    .color-darkgray {
        color: #768891;
    }

    .width-80 {
        width: 80px;
    }

    .img-partner-invite {
        width: 57px;
        height: 57px;
    }
</style>
